
interface FilterSidebarProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  selectedRegion: string;
  setSelectedRegion: (region: string) => void;
  priceRange: string;
  setPriceRange: (range: string) => void;
}

export function FilterSidebar({
  selectedCategory,
  setSelectedCategory,
  selectedRegion,
  setSelectedRegion,
  priceRange,
  setPriceRange,
}: FilterSidebarProps) {
  const categories = [
    { id: 'all', name: '전체', icon: 'ri-apps-line' },
    { id: 'fishing-gear', name: '어구류', icon: 'ri-anchor-line', subcategories: ['그물', '로프', '부표', '어구 부속품'] },
    { id: 'deck-equipment', name: '갑판용품', icon: 'ri-ship-line', subcategories: ['Wire', 'Block', 'Shackle', '체인', '갑판 부속품'] },
    { id: 'engine-parts', name: '기관물품', icon: 'ri-settings-3-line', subcategories: ['엔진 부품', '필터', '오일', '냉각 시스템', '전기 부품'] },
  ];

  const regions = [
    { id: 'all', name: '전국' },
    { id: 'busan', name: '부산' },
    { id: 'boryeong', name: '보령' },
    { id: 'mokpo', name: '목포' },
    { id: 'yeosu', name: '여수' },
    { id: 'tongyeong', name: '통영' },
    { id: 'pohang', name: '포항' },
    { id: 'jeju', name: '제주' },
  ];

  const priceRanges = [
    { id: 'all', name: '전체 가격' },
    { id: 'under-100k', name: '10만원 이하' },
    { id: '100k-500k', name: '10만원 - 50만원' },
    { id: '500k-1m', name: '50만원 - 100만원' },
    { id: '1m-5m', name: '100만원 - 500만원' },
    { id: 'over-5m', name: '500만원 이상' },
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-amber-100 p-6 sticky top-24">
      <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2">
        <i className="ri-filter-3-line text-amber-600"></i>
        필터
      </h3>

      {/* Category Filter */}
      <div className="mb-8">
        <h4 className="text-sm font-semibold text-gray-700 mb-3">카테고리</h4>
        <div className="space-y-2">
          {categories.map((category) => (
            <div key={category.id}>
              <button
                onClick={() => setSelectedCategory(category.id)}
                className={`w-full text-left px-4 py-2.5 rounded-lg transition-all flex items-center gap-3 cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-amber-50 text-amber-800 font-medium border border-amber-200'
                    : 'text-gray-600 hover:bg-amber-50/50'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span className="text-sm">{category.name}</span>
              </button>
              {category.subcategories && selectedCategory === category.id && (
                <div className="ml-10 mt-2 space-y-1">
                  {category.subcategories.map((sub) => (
                    <button
                      key={sub}
                      className="w-full text-left px-3 py-1.5 text-xs text-gray-600 hover:text-amber-700 transition-colors cursor-pointer"
                    >
                      {sub}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Region Filter */}
      <div className="mb-8">
        <h4 className="text-sm font-semibold text-gray-700 mb-3">제조 지역</h4>
        <div className="space-y-2">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setSelectedRegion(region.id)}
              className={`w-full text-left px-4 py-2 rounded-lg transition-all text-sm cursor-pointer ${
                selectedRegion === region.id
                  ? 'bg-amber-50 text-amber-800 font-medium border border-amber-200'
                  : 'text-gray-600 hover:bg-amber-50/50'
              }`}
            >
              {region.name}
            </button>
          ))}
        </div>
      </div>

      {/* Price Range Filter */}
      <div>
        <h4 className="text-sm font-semibold text-gray-700 mb-3">가격대</h4>
        <div className="space-y-2">
          {priceRanges.map((range) => (
            <button
              key={range.id}
              onClick={() => setPriceRange(range.id)}
              className={`w-full text-left px-4 py-2 rounded-lg transition-all text-sm cursor-pointer ${
                priceRange === range.id
                  ? 'bg-amber-50 text-amber-800 font-medium border border-amber-200'
                  : 'text-gray-600 hover:bg-amber-50/50'
              }`}
            >
              {range.name}
            </button>
          ))}
        </div>
      </div>

      {/* Reset Button */}
      <button
        onClick={() => {
          setSelectedCategory('all');
          setSelectedRegion('all');
          setPriceRange('all');
        }}
        className="w-full mt-6 px-4 py-2.5 border border-amber-300 text-amber-700 rounded-lg hover:bg-amber-50 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
      >
        <i className="ri-refresh-line mr-2"></i>
        필터 초기화
      </button>
    </div>
  );
}
